import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireEmailVerification?: boolean;
}

export function ProtectedRoute({ 
  children, 
  requireEmailVerification = false 
}: ProtectedRouteProps) {
  const { isAuthenticated, user, emailVerificationRequired } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  // Check both Redux state and localStorage as backup
  const token = localStorage.getItem('client_token');
  const isLoggedIn = isAuthenticated || !!token;

  if (!isLoggedIn) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check email verification requirement
  if (requireEmailVerification && (emailVerificationRequired || !user?.emailVerified)) {
    return <Navigate to="/verify-email" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
